import ReactDOM from 'react-dom';
import './SubcategoriesActionsPortal.css';

export const SubcategoriesActionsPortal = ({
    children,
}) => {
    const portalElementId = 'subcategories-actions-portal';
    const portalElement = document.getElementById(portalElementId);

    return ReactDOM.createPortal(
        children,
        portalElement,
    );
};
